import { MediaGet, MediaShort } from '@insurance/api/requests'
import { Text } from '@shared/components'
import { getBlobFromUrl } from '@shared/utils'
import { Card, Image as AntImage, Skeleton } from 'antd'
import { useEffect, useState } from 'react'

import { useStyles } from './styles'

type Props = { fileMedia?: MediaGet | MediaShort }

const SIZE = 80

export const PreviewMedia = ({ fileMedia }: Props) => {
  const [url, setUrl] = useState<string>()
  const [loading, setLoading] = useState(true)
  const { styles } = useStyles({ size: SIZE })

  useEffect(() => {
    if (!fileMedia) return

    const getFileUrl = async () => {
      setLoading(true)
      const blob = await getBlobFromUrl(fileMedia)

      if (blob) {
        const url = window.URL.createObjectURL(blob)

        const image = new Image()

        image.src = url
        image.onload = () => {
          setUrl(url)
          setLoading(false)
        }
        image.onerror = () => {
          setLoading(false)
        }
      } else {
        setLoading(false)
      }
    }

    getFileUrl()

    return () => setUrl(undefined)
  }, [fileMedia])

  if (!fileMedia) return null

  const fileName = fileMedia?.name?.split('.')?.pop()

  if (loading)
    return <Skeleton.Image active style={{ width: SIZE, height: SIZE }} />

  return url ? (
    <AntImage src={url} width={SIZE} height={SIZE} />
  ) : (
    <Card className={styles.extensionCard}>
      <Text strong color="colorPrimary">
        {fileName?.toUpperCase()}
      </Text>
    </Card>
  )
}
